/* eslint-disable react/no-unescaped-entities */
import { Typography } from '@design-system/components/typography/typography';
import { faScissors } from '@fortawesome/pro-solid-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import mediaInfoTooltipIcon from '/static/images/media-info-tooltip.png';
import workoutVideoIcon from '/static/images/workout-video.jpg';

export const MediaTooltips = () => (
  <div className="flex gap-2">
    <Tooltip
      title={<EditMediaTooltipContent />}
      variant="dark"
      arrow={false}
      tooltipProps={{ maxWidth: '400px', padding: '16px' }}
    >
      <FontAwesomeIcon icon={faScissors} className="cursor-pointer" />
    </Tooltip>
    <Tooltip
      title={<InfoMediaTooltipContent />}
      variant="dark"
      arrow={false}
      tooltipProps={{ maxWidth: '400px', padding: '16px' }}
    >
      <FontAwesomeIcon icon={faCircleInfo} className="cursor-pointer" />
    </Tooltip>
  </div>
);

const InfoMediaTooltipContent = () => (
  <div className="flex gap-4 justify-center items-center">
    <div className="flex flex-col">
      <Typography variant="body" className="pb-2">
        Exercise clip
      </Typography>
      <Typography variant="body" className="font-normal pb-5">
        Record a single repetition of the exercise in portrait mode. They are
        displayed in fullscreen, for best consumer experience.
      </Typography>
      <Typography className="font-normal">Format: Portrait (9:16)</Typography>
      <Typography className="font-normal">Length: max 60 sec.</Typography>
      <Typography className="font-normal">Browser: Safari or Chrome</Typography>
    </div>
    <img src={mediaInfoTooltipIcon} className="w-[134px] h-[204px]" />
  </div>
);

const EditMediaTooltipContent = () => (
  <div className="flex gap-4 justify-center items-center">
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Typography variant="body">Edit on desktop</Typography>
        <Typography variant="body" as="div">
          Use{' '}
          <a href="https://online-video-cutter.com/" className="underline">
            Video Cutter
          </a>{' '}
          to crop your video and compress it to less than 100 MB if necessary.
          Select '720p' in quality and 'mp4' in format. Remember to shoot in
          portrait mode.
        </Typography>
      </div>
      <div className="flex flex-col gap-2">
        <Typography variant="body">Edit on mobile</Typography>
        <Typography variant="body">
          Use the app{' '}
          <a
            href="https://apps.apple.com/us/app/splice-video-editor-maker/id409838725"
            className="underline"
          >
            Splice
          </a>{' '}
          from the App Store to trim your video. Use{' '}
          <a
            href="https://apps.apple.com/us/app/video-compressor/id482465886"
            className="underline"
          >
            Video Compressor
          </a>{' '}
          to have longer video.
        </Typography>
      </div>
    </div>
  </div>
);

export const IntroTooltip = () => (
  <Tooltip
    title={<IntroTooltipContent />}
    variant="dark"
    arrow={false}
    tooltipProps={{ maxWidth: '400px', padding: '16px' }}
  >
    <FontAwesomeIcon icon={faCircleInfo} className="cursor-pointer" />
  </Tooltip>
);

const IntroTooltipContent = () => (
  <div className="flex">
    <div className="flex flex-col gap-2">
      <Typography variant="body">Introduction video</Typography>
      <Typography>
        Record a short video of yourself saying what the workout is about. (ex.
        “Today I did heavy chest with focus on…”)
      </Typography>
      <div className="flex flex-col">
        <Typography>Format: Portrait (9:16)</Typography>
        <Typography>Length: max 15 sec.</Typography>
        <Typography>Browser: Safari or Chrome</Typography>
      </div>
    </div>
    <img
      className="w-[170px]"
      src={workoutVideoIcon}
      alt="Workout Video Icon"
    />
  </div>
);
